import { sha256 } from 'js-sha256';

const hashMemberId = (memberId) => sha256(memberId);

export default hashMemberId;
